import { useEffect } from 'react';

export default function SEO({ page }) {
  useEffect(() => {
    const fetchSEO = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/seo-settings`);
        const data = await response.json();
        
        // Find SEO settings for this page
        const pageSEO = data.find(s => s.page === page);
        
        if (pageSEO) {
          // Update page title
          if (pageSEO.title) {
            document.title = pageSEO.title;
          }
          
          // Update meta description
          if (pageSEO.meta_description) {
            let metaDesc = document.querySelector('meta[name="description"]');
            if (!metaDesc) {
              metaDesc = document.createElement('meta');
              metaDesc.name = 'description';
              document.head.appendChild(metaDesc);
            }
            metaDesc.content = pageSEO.meta_description;
          }
          
          // Update Open Graph title
          if (pageSEO.og_title) {
            let ogTitle = document.querySelector('meta[property="og:title"]');
            if (!ogTitle) {
              ogTitle = document.createElement('meta');
              ogTitle.setAttribute('property', 'og:title');
              document.head.appendChild(ogTitle);
            }
            ogTitle.content = pageSEO.og_title;
          }
          
          // Update Open Graph description
          if (pageSEO.og_description) {
            let ogDesc = document.querySelector('meta[property="og:description"]');
            if (!ogDesc) {
              ogDesc = document.createElement('meta');
              ogDesc.setAttribute('property', 'og:description');
              document.head.appendChild(ogDesc);
            }
            ogDesc.content = pageSEO.og_description;
          }
          
          // Update Open Graph image
          if (pageSEO.og_image) {
            let ogImage = document.querySelector('meta[property="og:image"]');
            if (!ogImage) {
              ogImage = document.createElement('meta');
              ogImage.setAttribute('property', 'og:image');
              document.head.appendChild(ogImage);
            }
            ogImage.content = pageSEO.og_image;
          }
          
          // Add Twitter Card tags
          if (pageSEO.og_title) {
            let twitterTitle = document.querySelector('meta[name="twitter:title"]');
            if (!twitterTitle) {
              twitterTitle = document.createElement('meta');
              twitterTitle.name = 'twitter:title';
              document.head.appendChild(twitterTitle);
            }
            twitterTitle.content = pageSEO.og_title;
          }
          
          if (pageSEO.og_description) {
            let twitterDesc = document.querySelector('meta[name="twitter:description"]');
            if (!twitterDesc) {
              twitterDesc = document.createElement('meta');
              twitterDesc.name = 'twitter:description';
              document.head.appendChild(twitterDesc);
            }
            twitterDesc.content = pageSEO.og_description;
          }
          
          if (pageSEO.og_image) {
            let twitterImage = document.querySelector('meta[name="twitter:image"]');
            if (!twitterImage) {
              twitterImage = document.createElement('meta');
              twitterImage.name = 'twitter:image';
              document.head.appendChild(twitterImage);
            }
            twitterImage.content = pageSEO.og_image;
            
            // Add Twitter card type
            let twitterCard = document.querySelector('meta[name="twitter:card"]');
            if (!twitterCard) {
              twitterCard = document.createElement('meta');
              twitterCard.name = 'twitter:card';
              document.head.appendChild(twitterCard);
            }
            twitterCard.content = 'summary_large_image';
          }
        }
      } catch (error) {
        console.error('Error fetching SEO settings:', error);
      }
    };
    
    fetchSEO();
  }, [page]);

  return null;
}
